import { getFilterParamObject } from '../../../utils/apiRequests/getFilterParamObject';

// getFilterParamObject collapses array-valued `or`/`and` groups to their first branch,
// so those entries are recursed here instead; everything else is delegated to it unchanged.
export const getReferenceFilterParamObject = (
  activeFilters: Record<string, any> | null
): Record<string, any> => {
  if (!activeFilters) {
    return {};
  }

  const flatEntries: Record<string, any> = {};
  const arrayEntries: Record<string, any> = {};

  Object.keys(activeFilters).forEach((key) => {
    if (Array.isArray(activeFilters[key])) {
      arrayEntries[key] = activeFilters[key];
    } else {
      flatEntries[key] = activeFilters[key];
    }
  });

  const filtersObject = getFilterParamObject(flatEntries);

  Object.keys(arrayEntries).forEach((key) => {
    filtersObject[key] = arrayEntries[key].map((branch: Record<string, any>) =>
      getReferenceFilterParamObject(branch)
    );
  });

  return filtersObject;
};
